(function (ws) {
    'use strict';
    ws.models.minicart = Backbone.Model.extend({
        defaults: {
            totalQty: '0',
            totalItems: ''
        },

        /**
         * Fetches Mini Cart
         * @returns {string} location of jqXHR Object
         *
         */
        urlRoot: globals.path.api.westcon.miniCart

    });
})(westcon);
